import React from 'react'
import { Link } from 'react-router-dom'
import { ILNoData } from 'src/assets'

function Kategori({ group }) {
    return (
        <div>
            <aside className="widget widget-categories ttm-bgcolor-white clearfix">
                <h3 className="widget-title">Organisasi</h3>
                <ul className="mb-4">
                    {
                        group.Agency.length !== 0 ?
                            group.Agency.map((v, i) => {
                                return (
                                    i <= 4 &&
                                    <li key={i}><Link to={`/organisasi/detail/${v.Slug}`}>{v.Name} ({v.DatasetCount})</Link></li>
                                )
                            })
                        :
                            <center>
                                <img src={ILNoData} width={100} className="img-fluid" />
                                <div className='mt-2'>
                                    <span>Empty Data</span>
                                </div>
                            </center>
                    }
                </ul>
                {
                    group.Agency.length !== 0 ?? <center><Link to={'/organisasi'} className=""><i className="fa fa-angle-down" /> Lihat Semua</Link></center>
                }
            </aside>
            <aside className="widget widget-categories ttm-bgcolor-white clearfix">
                <h3 className="widget-title">Kategori</h3>
                <ul>
                    {
                        group.Category.length !== 0 ?
                            group.Category.map((v, i) => {
                                return (
                                    <li key={i}><Link to={`/kategori/detail/${v.Slug}`}>{v.Name} ({v.DatasetCount})</Link></li>
                                )
                            })
                        :
                            <center>
                                <img src={ILNoData} width={100} className="img-fluid" />
                                <div className='mt-2'>
                                    <span>Empty Data</span>
                                </div>
                            </center>
                    }
                </ul>
            </aside>
            <aside className="widget tagcloud-widget ttm-bgcolor-white clearfix">
                <h3 className="widget-title">Tag</h3>
                <div className="tagcloud mb-4">
                    {
                        group.Tag.length !== 0 ?
                            group.Tag.map((v, i) => {
                                return (
                                    i <= 4 &&
                                    <Link key={i} to={`/tag/detail/${v.Slug}`} className="tag-cloud-link">{v.Name} ({v.DatasetCount})</Link>

                                )
                            })
                        :
                            <center>
                                <img src={ILNoData} width={100} className="img-fluid" />
                                <div className='mt-2'>
                                    <span>Empty Data</span>
                                </div>
                            </center>
                    }
                </div>
                {
                    group.Tag.length !== 0 ?? <center><Link to={'/tag'} className=""><i className="fa fa-angle-down" /> Lihat Semua</Link></center>
                }
                
            </aside>
            <aside className="widget widget-categories ttm-bgcolor-white clearfix">
                <h3 className="widget-title">Format</h3>
                <ul className="mb-4">
                    {
                        group.DatasetType.length !== 0 ?
                            group.DatasetType.map((v, i) => {
                                return (
                                    <li key={i}><Link to={`/file/detail/${v.Slug}`}>{v.Name} ({v.DatasetCount})</Link></li>
                                )
                            })
                        :
                            <center>
                                <img src={ILNoData} width={100} className="img-fluid" />
                                <div className='mt-2'>
                                    <span>Empty Data</span>
                                </div>
                            </center>
                    }
                </ul>
            </aside>

        </div>
    )
}

export default Kategori
